import { InAppMessage } from "../../../model/model"
import { HackleUser } from "../../../model/model"
import Workspace from "../../../workspace/Workspace"
import { EvaluatorKey, EvaluatorRequest } from "../Evaluator"

export abstract class InAppMessageEvaluatorRequest implements EvaluatorRequest {
  abstract workspace: Workspace
  abstract user: HackleUser
  abstract inAppMessage: InAppMessage

  get key(): EvaluatorKey {
    return new EvaluatorKey("IN_APP_MESSAGE", this.inAppMessage.id)
  }
}
